import React, { FC } from 'react';
import { Field } from 'formik';
import { Tooltip } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import RadioField from 'components/Fields/Radio';

// own components
import InfoIcon from './InfoIcon';

// own constants
import { TOP_FIELD_NAME } from '../../../LiveLikeChatForm';

const Div = styled.div`
  display: flex;
  align-items: center;

  & label {
    margin-right: 0.25em;
    width: fit-content;

    span {
      width: fit-content;
    }
  }
`;

interface Props {
  value: string;
  label: string;
  tooltip: string;
  tag: string;
}

const ModerationRadioField: FC<Props> = ({ value, label, tooltip, tag }) => (
  <Div>
    <Field name={`${TOP_FIELD_NAME}.content_filter`} value={value} label={label} component={RadioField} tag={tag} />
    <Tooltip placement="right" content={tooltip}>
      <InfoIcon />
    </Tooltip>
  </Div>
);

export default ModerationRadioField;
